import React, { createContext, useContext, PropsWithChildren, useRef } from 'react';
import { user, rollouts, localeSettings, abTests, notificationSoundEnabled } from '../../../PropTypes';
import { User, Rollouts } from '../../types';

export const HeaderContext = createContext<LegacyContext | undefined>(undefined);

interface Currency {
    code: string;
    template: string;
    symbol: string;
    name: string;
    exchange_rate: number;
}

interface SupportedCurrency {
    currency: string;
    currency_symbol: string;
    currency_name: string;
}

interface LegacyContext {
    user: User;
    rollouts: Rollouts;
    locale: string;
    displayedLocale: string;
    selectedCurrency: string;
    supportedCurrencies: SupportedCurrency[];
    supportedLanguages: string[];
    abTests: Record<string, unknown>;
    currency: Currency;
    notificationSoundEnabled: boolean;
}

export const HeaderContextProvider = ({ children }: PropsWithChildren<object>, legacyContext: LegacyContext) => {
    const valueRef = useRef(legacyContext);

    return <HeaderContext.Provider value={valueRef.current}>{children}</HeaderContext.Provider>;
};

HeaderContextProvider.contextTypes = {
    user,
    rollouts,
    currency: localeSettings.currency,
    locale: localeSettings.locale,
    displayedLocale: localeSettings.displayedLocale,
    selectedCurrency: localeSettings.selectedCurrency,
    supportedCurrencies: localeSettings.supportedCurrencies,
    supportedLanguages: localeSettings.supportedLanguages,
    abTests,
    notificationSoundEnabled,
};

export const useHeaderContext = () => {
    const context = useContext(HeaderContext);

    if (!context) {
        throw new Error('useHeaderContext must be used within a HeaderContextProvider');
    }

    return context;
};
